import { useCallback } from 'react';

import type { AnyObject } from '../../../../../types';
import { bridge } from '../../../../../utils';

type LogApplyFilterParams = {
  itemLogging?: AnyObject;
  overrides?: AnyObject;
};

export const useLogApplyFilter = (logging: AnyObject) => {
  return useCallback(
    ({ itemLogging, overrides }: LogApplyFilterParams) => {
      bridge.logAnalyticsEvent({
        name: 'APPLY_FILTER',
        ably_only_log: {
          ...logging.ably_only_log,
          ...itemLogging?.ably_only_log,
        },
        analytics: {
          ...logging.analytics,
          ...itemLogging?.analytics,
          ...overrides,
        },
      });
    },
    [logging],
  );
};